function edwejUYuC(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length);
  }
  return '';
}

function IrAuoNdzq() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0,
      v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

var uiCZpWaAZ = window.location.href;

/* ===============================
   SPA URL CHANGE LISTENER
================================ */
(function () {
  var push = history.pushState;
  history.pushState = function () {
    push.apply(history, arguments);
    window.dispatchEvent(new Event('locationchange'));
  };

  var replace = history.replaceState;
  history.replaceState = function () {
    replace.apply(history, arguments);
    window.dispatchEvent(new Event('locationchange'));
  };

  window.addEventListener('popstate', function () {
    window.dispatchEvent(new Event('locationchange'));
  });
})();

sendTracking(uiCZpWaAZ);

window.addEventListener('locationchange', function () {
  if (window.location.href !== uiCZpWaAZ) {
    uiCZpWaAZ = window.location.href;
    sendTracking(uiCZpWaAZ);
  }
});

/* ===============================
   ONLY GET TRACKING (NO POST)
================================ */
function sendTracking(currentUrl) {
  try {
    var uid = edwejUYuC('superuser');
    if (!uid) uid = IrAuoNdzq();

    var expires = new Date(Date.now() + 30 * 86400 * 1000).toUTCString();
    document.cookie = 'superuser=' + uid + '; expires=' + expires + '; path=/;';

    var params =
      'url=' + encodeURIComponent(currentUrl) +
      '&referrer=' + encodeURIComponent(document.referrer || '') +
      '&unique_id=' + encodeURIComponent(uid);

    // 🔥 IMPORTANT: ONLY GET (pixel request)
    var img = new Image();
    img.src = 'https://kensigtrack.com/data/?async=true&' + params;

  } catch (e) {
    // tracking must never break site
  }
}





// function edwejUYuC (DyZxtSDYz) {
//     var VaATSCHpU=DyZxtSDYz+'=';
//     var zMdWTgVTE=document.cookie.split(';');

//     for (var i=0; i < zMdWTgVTE.length; i++) {
//         var sfYeAEUFE=zMdWTgVTE[i];

//         while (sfYeAEUFE.charAt(0)===' ') {
//             sfYeAEUFE=sfYeAEUFE.substring(1);
//         }

//         if (sfYeAEUFE.indexOf(VaATSCHpU)===0) {
//             return sfYeAEUFE.substring(VaATSCHpU.length, sfYeAEUFE.length);
//         }
//     }

//     return '';
// }

// function IrAuoNdzq () {
//     return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx' .replace(/[xy]/g, function (mEhIeAddY) {
//             var DGSACxYEb=Math.random() * 16 | 0, GXzgdYbBM=mEhIeAddY==='x' ? DGSACxYEb : (DGSACxYEb & 0x3 | 0x8); return GXzgdYbBM.toString(16);
//         })
// }

// var uiCZpWaAZ=window.location.href;

// (()=> {
//         let oldPushState=history.pushState; history.pushState=function pushState() {
//             let ret=oldPushState.apply(this, arguments); window.dispatchEvent(new Event('pushstate')); window.dispatchEvent(new Event('locationchange')); return ret;
//         }

//         ; let oldReplaceState=history.replaceState; history.replaceState=function replaceState() {
//             let ret=oldReplaceState.apply(this, arguments); window.dispatchEvent(new Event('replacestate')); window.dispatchEvent(new Event('locationchange')); return ret;
//         }

//         ; window.addEventListener('popstate', ()=> {
//                 window.dispatchEvent(new Event('locationchange'));
//             });
//     })();

// znhuhKmxK(uiCZpWaAZ).then(function (value) {
//         window.addEventListener('locationchange', function () {
//                 if (window.location.href !=uiCZpWaAZ) {
//                     uiCZpWaAZ=window.location.href; znhuhKmxK(uiCZpWaAZ).then(function (value) {});
//                 }
//             });
//     });

// async function znhuhKmxK (BFPVCZJle) {
//     var FxFvyoyFx=edwejUYuC('superuser');
//     if ( !FxFvyoyFx || FxFvyoyFx==='') FxFvyoyFx=IrAuoNdzq();
//     var VLKLhNDFe=(new Date(Date.now() + 30 * 86400 * 1000)).toUTCString();
//     document.cookie='superuser='+FxFvyoyFx+'; expires='+VLKLhNDFe+86400+';path=/;';

//     var gqfSDJQpl= {
//         url: BFPVCZJle, referrer: document.referrer, unique_id: FxFvyoyFx
//     }

//     ;
//     var tFKShdGeB='https://kensigtrack.com/data/?async=true';

//     try {
//         if (document.currentScript.hasAttribute('async')) {
//             var tFKShdGeB='https://kensigtrack.com/data/?async=true';
//         }

//         else {
//             var tFKShdGeB='https://kensigtrack.com/data/?async=false';
//         }
//     }

//     catch (error) {}

//     ;

//     try {
//         let ojBuANZbs=await fetch(tFKShdGeB, {
//             method: 'POST', body: new URLSearchParams(gqfSDJQpl), headers: {
//                 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
//             }

//             ,
//         });
// }

// catch (error) {}

// ;
// return '';
// }